import { Component, OnInit } from '@angular/core';
import { ActivationStart, Router } from '@angular/router';
import { FooterModel } from '../model/layout/footer/footer.model';
import { LayoutService } from '../service/layout.service';

@Component({
  selector: 'footer[app-footer]',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  public isLastPage = false;
  public isPrivacyInfoActive = false;
  public layoutFooterDetails: FooterModel = new FooterModel();

  constructor(
    public layoutService: LayoutService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((event: any) => {
      if (event instanceof ActivationStart) {
        this.isLastPage = event.snapshot?.routeConfig?.path === 'Q2';
      }
    });
    this.getLayoutFooterDetails();
  }

  public getLayoutFooterDetails(): void {
    this.layoutService.getLayoutFooterDetails().subscribe((res) => {
      if (res) {
        this.layoutFooterDetails = res;
      }
    });
  }

  public toggleIsActive(): void {
    this.isPrivacyInfoActive = !this.isPrivacyInfoActive;
  }
}
